// extracted by mini-css-extract-plugin
export default {"supportChat":"N6n49jchqBBKveRg32AB"};